// extracted by mini-css-extract-plugin
export var gif = "_cv-0";